var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilledStarIconLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Star 4",
    filter: "url(#filter0_d_352_1969)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7881 4.31166C15.3269 2.6533 17.6731 2.6533 18.2119 4.31166L20.1371 10.2369C20.3781 10.9785 21.0692 11.4807 21.849 11.4807H28.0792C29.8229 11.4807 30.5479 13.712 29.1372 14.7369L24.0969 18.3989C23.466 18.8572 23.202 19.6697 23.443 20.4113L25.3682 26.3366C25.9071 27.9949 24.009 29.374 22.5983 28.349L17.558 24.687C16.9271 24.2287 16.0729 24.2287 15.442 24.687L10.4017 28.349C8.991 29.374 7.09293 27.9949 7.63177 26.3366L9.55699 20.4114C9.79797 19.6697 9.53398 18.8572 8.9031 18.3989L3.8628 14.7369C2.45212 13.712 3.17711 11.4807 4.92081 11.4807H11.151C11.9308 11.4807 12.6219 10.9785 12.8629 10.2369L14.7881 4.31166Z",
    fill: "#FFC805"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_352_1969",
    x: 0.717188,
    y: 0.667871,
    width: 31.5656,
    height: 30.4331,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_352_1969"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_352_1969",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledStarIconLarge);
export default __webpack_public_path__ + "static/media/filledStarIconLarge.1f595c62069a5092efa6dd611332c2d7.svg";
export { ForwardRef as ReactComponent };